// Wektorowe szrafury litologiczne jako SVG <pattern> — odpowiednik CSS z HatchingFill.
// Wzory rysują wyłącznie znaczniki (linie/kropki) na przezroczystym tle; kolor niesie prostokąt bazowy.
// Dzięki temu ten sam SVG renderuje się w przeglądarce i jest transkodowany do wektorowego PDF (Apache FOP).

const STROKE = 'rgba(0,0,0,0.62)';
const SW = 1.0; // grubość kreski (widoczna też w wektorowym PDF/FOP)

/** Zwraca `url(#hatch-XXX)` dla nazwy wzoru, albo 'none' dla SOLID/braku. */
export function lithoFill(pattern: string | null | undefined): string {
  if (!pattern || pattern === 'SOLID') return 'none';
  return `url(#hatch-${pattern})`;
}

/** Zestaw definicji <pattern> — wstawić raz w <defs> karty. */
export function LithoPatternDefs() {
  return (
    <>
      <pattern id="hatch-DOTS" patternUnits="userSpaceOnUse" width="6" height="6">
        <circle cx="3" cy="3" r="1.1" fill={STROKE} />
      </pattern>

      <pattern id="hatch-HORIZONTAL_LINES" patternUnits="userSpaceOnUse" width="6" height="5">
        <line x1="0" y1="4.5" x2="6" y2="4.5" stroke={STROKE} strokeWidth={SW} />
      </pattern>

      <pattern id="hatch-VERTICAL_LINES" patternUnits="userSpaceOnUse" width="5" height="6">
        <line x1="4.5" y1="0" x2="4.5" y2="6" stroke={STROKE} strokeWidth={SW} />
      </pattern>

      {/* diagonalne — jawne ścieżki (FOP/Batik ignoruje patternTransform="rotate") */}
      <pattern id="hatch-DIAGONAL_LINES" patternUnits="userSpaceOnUse" width="8" height="8">
        <path d="M0 8 L8 0 M-2 2 L2 -2 M6 10 L10 6" fill="none" stroke={STROKE} strokeWidth={SW} />
      </pattern>

      <pattern id="hatch-DIAGONAL_LINES_REVERSE" patternUnits="userSpaceOnUse" width="8" height="8">
        <path d="M0 0 L8 8 M-2 6 L2 10 M6 -2 L10 2" fill="none" stroke={STROKE} strokeWidth={SW} />
      </pattern>

      <pattern id="hatch-CROSS" patternUnits="userSpaceOnUse" width="7" height="7">
        <line x1="0" y1="0" x2="7" y2="7" stroke={STROKE} strokeWidth={SW} />
        <line x1="7" y1="0" x2="0" y2="7" stroke={STROKE} strokeWidth={SW} />
      </pattern>

      <pattern id="hatch-BRICKS" patternUnits="userSpaceOnUse" width="16" height="12">
        <line x1="0" y1="6" x2="16" y2="6" stroke={STROKE} strokeWidth={SW} />
        <line x1="0" y1="11.5" x2="16" y2="11.5" stroke={STROKE} strokeWidth={SW} />
        <line x1="4" y1="0" x2="4" y2="6" stroke={STROKE} strokeWidth={SW} />
        <line x1="12" y1="6" x2="12" y2="12" stroke={STROKE} strokeWidth={SW} />
      </pattern>

      <pattern id="hatch-TRIANGLES" patternUnits="userSpaceOnUse" width="10" height="8">
        <path d="M0 8 L5 0 L10 8" fill="none" stroke={STROKE} strokeWidth={SW} />
      </pattern>

      <pattern id="hatch-WAVES" patternUnits="userSpaceOnUse" width="14" height="6">
        <path d="M0 5 Q3.5 1 7 5 Q10.5 1 14 5" fill="none" stroke={STROKE} strokeWidth={SW} />
      </pattern>

      {/* --- rozszerzenie wg DIN 4023 --- */}
      <pattern id="hatch-CIRCLES" patternUnits="userSpaceOnUse" width="10" height="10">
        <circle cx="3" cy="3" r="2" fill="none" stroke={STROKE} strokeWidth={0.8} />
        <circle cx="8" cy="8" r="2" fill="none" stroke={STROKE} strokeWidth={0.8} />
      </pattern>

      <pattern id="hatch-PEBBLES" patternUnits="userSpaceOnUse" width="16" height="13">
        <ellipse cx="8" cy="6.5" rx="4.5" ry="3" fill="none" stroke={STROKE} strokeWidth={0.9} />
        <circle cx="8" cy="6.5" r="0.7" fill={STROKE} />
        <ellipse cx="0" cy="0" rx="3.5" ry="2.4" fill="none" stroke={STROKE} strokeWidth={0.9} />
        <ellipse cx="16" cy="13" rx="3.5" ry="2.4" fill="none" stroke={STROKE} strokeWidth={0.9} />
      </pattern>

      <pattern id="hatch-DASHES" patternUnits="userSpaceOnUse" width="10" height="8">
        <line x1="0.5" y1="3" x2="5" y2="3" stroke={STROKE} strokeWidth={SW} />
        <line x1="5.5" y1="7" x2="10" y2="7" stroke={STROKE} strokeWidth={SW} />
      </pattern>

      <pattern id="hatch-BRICKS_DIAGONAL" patternUnits="userSpaceOnUse" width="16" height="12">
        <line x1="0" y1="6" x2="16" y2="6" stroke={STROKE} strokeWidth={SW} />
        <line x1="0" y1="11.5" x2="16" y2="11.5" stroke={STROKE} strokeWidth={SW} />
        <line x1="4" y1="0" x2="4" y2="6" stroke={STROKE} strokeWidth={SW} />
        <line x1="12" y1="6" x2="12" y2="12" stroke={STROKE} strokeWidth={SW} />
        <line x1="7" y1="5" x2="11" y2="1" stroke={STROKE} strokeWidth={0.7} />
        <line x1="4" y1="11" x2="8" y2="7" stroke={STROKE} strokeWidth={0.7} />
      </pattern>

      <pattern id="hatch-BRICKS_MARL" patternUnits="userSpaceOnUse" width="16" height="12">
        <line x1="0" y1="6" x2="16" y2="6" stroke={STROKE} strokeWidth={SW} />
        <line x1="0" y1="11.5" x2="16" y2="11.5" stroke={STROKE} strokeWidth={SW} />
        <line x1="4" y1="0" x2="4" y2="6" stroke={STROKE} strokeWidth={SW} />
        <line x1="12" y1="6" x2="12" y2="12" stroke={STROKE} strokeWidth={SW} />
        <line x1="10" y1="1.5" x2="10" y2="4.5" stroke={STROKE} strokeWidth={0.7} />
        <line x1="6" y1="7.5" x2="6" y2="10.5" stroke={STROKE} strokeWidth={0.7} />
      </pattern>
    </>
  );
}
